import HundredBricksAPIError from '../../HundredBricksAPIError';
class SetTaxIdError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SetTaxIdError', ...args);
    }
}
export default SetTaxIdError;
